import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  buttonContainer: { flex: 1, justifyContent: "flex-end", marginBottom: 50 },
  cell: {
    borderColor: colors.placeholder,
    borderRadius: 10,
    borderWidth: 1,
    fontSize: 24,
    height: 40,
    lineHeight: 33,
    textAlign: "center",
    width: 40,
  },
  container: { height: "100%", marginHorizontal: 10},
  errorCell: {
    borderColor: colors.error,
  },
  fieldTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 6,
    marginTop: 10,
    paddingLeft: 4,
  },
  modalContainer: {
    backgroundColor: colors.white,
    borderRadius: 10,
    height: 210,
    padding: 20,
    maxWidth: 800,
    alignSelf: "center",
  },
  modalDescriptionText: {
    fontFamily: typography.primary.normal,
    marginBottom: 10,
    textAlign: "center",
  },
  modalImage: {
    alignSelf: "center",
    height: 200,
    position: "absolute",
    top: -120,
    width: 200,
  },
  modalTextContainer: { alignItems: "center", marginTop: 50 },
  modalTitleText: {
    fontFamily: typography.primary.normal,
    fontSize: 18,
    marginBottom: 10,
    textAlign: "center",
  },
  rootCodeStyle: { marginBottom: 10 },
  titleText: {
    fontFamily: typography.primary.normal,
    fontSize: 23,
    marginBottom: 40,
    marginTop: 10,
  },
})
